import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import SubmitButton from '../Buttons/SubmitButton';
import SimpleInput from '../Input/SimpleInput';
import ForgetPassword from '../ForgetPassword/ForgetPassword';
import { Box, Typography, Link, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';

const Login = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [isResetOpen, setIsResetOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login: loginUser } = useAuth();

  const from = location.state?.from?.pathname || '/dashboard';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await loginUser(formData);
      toast.success('Login successful! Welcome back!');
      // Ensure token is stored before redirect - use requestAnimationFrame to let React/Redux settle
      requestAnimationFrame(() => {
        navigate(from || '/dashboard', { replace: true });
      });
    } catch (error) {
      toast.error(error.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    setIsResetOpen(true);
  };

  const handleCloseReset = () => {
    setIsResetOpen(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          bgcolor: 'white',
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          width: '100%',
          maxWidth: 384,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, textAlign: 'center', color: 'grey.700', mb: 3 }}
        >
          Sign In
        </Typography>
        
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <SimpleInput
            type="email"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="e-mail"
            required
          />
          <SimpleInput
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Password"
            required
          />
          <SubmitButton disabled={loading}>
            {loading ? <CircularProgress size={20} color="inherit" /> : 'SIGN IN'}
          </SubmitButton>
        </Box>
        <Link
          component="button"
          onClick={handleForgotPassword}
          sx={{
            textAlign: 'center',
            mt: 2,
            color: 'blue.500',
            textDecoration: 'underline',
            '&:hover': { textDecoration: 'underline', color: 'blue.600' },
          }}
        >
          Forgot password?
        </Link>
        {isResetOpen && <ForgetPassword onClose={handleCloseReset} />}
      </Box>
    </Box>
  );
};

export default Login;